import { SubstitutionProductsApi } from '../types/api/substitution-products-api';
import { BaseRouteProps } from '../types/route-props';
import { SPRYKER_PRODUCTS_SUBSTITUTION } from '../constants';
import { getBrandName } from '../common';
import { Method, callAxios, AxiosRequestConfig } from '../axios';

export const substitutionProductsApiFetchers = {
  getSubstitutionProducts: async ({
    countryCode,
    languageCode,
    params,
  }: BaseRouteProps & {
    params?: SubstitutionProductsApi.GetSubstitutionProductsParams;
  }) => {
    const requestSettings: AxiosRequestConfig<unknown> = {
      method: Method.GET,
      url: SPRYKER_PRODUCTS_SUBSTITUTION,
      params: {
        'country-code': countryCode,
        'language-code': languageCode,
        brand: getBrandName(),
        ...params,
      },
    };
    try {
      const response = await callAxios<{
        response: any;
      }>(requestSettings);
      return { productSubstitutionsResponse: response.data, error: null };
    } catch (error) {
      return { productSubstitutionsResponse: null, error };
    }
  },
};
